(() => {
  const trackedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const storagePrefix = 'eclipse_attribution_';

  const storageGet = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  };

  const storageSet = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Tracking must never block browsing or form submission.
    }
  };

  const cleanValue = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);

  const readAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const attribution = {};

    trackedParams.forEach((key) => {
      const incoming = cleanValue(params.get(key));
      if (incoming) {
        storageSet(storagePrefix + key, incoming);
        attribution[key] = incoming;
      } else {
        const stored = cleanValue(storageGet(storagePrefix + key));
        if (stored) attribution[key] = stored;
      }
    });

    return attribution;
  };

  const publish = (eventName, payload, attempts = 0) => {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, payload);
      return;
    }

    if (attempts < 8) {
      window.setTimeout(() => publish(eventName, payload, attempts + 1), 250);
    }
  };

  const attribution = readAttribution();

  const persistCartAttribution = () => {
    const entries = Object.entries(attribution);
    if (!entries.length) return;

    const signature = entries.map(([key, value]) => `${key}:${value}`).join('|');
    if (storageGet('eclipse_cart_attribution') === signature) return;

    const attributes = Object.fromEntries(entries.map(([key, value]) => [
      `Eclipse ${key.replace('utm_', 'UTM ')}`,
      value,
    ]));
    attributes['Eclipse landing path'] = window.location.pathname.slice(0, 180);

    fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes }),
    })
      .then((response) => {
        if (response.ok) storageSet('eclipse_cart_attribution', signature);
      })
      .catch(() => {
        // Attribution is useful context, never a reason to interrupt shopping.
      });
  };

  persistCartAttribution();

  document.querySelectorAll('[data-ec-lead-tags]').forEach((field) => {
    const baseTags = field.value.split(',').map((tag) => cleanValue(tag)).filter(Boolean);
    const campaignTags = Object.entries(attribution).map(([key, value]) => `${key}_${value}`);
    field.value = [...new Set([...baseTags, ...campaignTags])].join(',');
  });

  document.querySelectorAll('[data-ec-attribution-field]').forEach((field) => {
    field.value = Object.entries(attribution)
      .map(([key, value]) => `${key}=${value}`)
      .join('; ');
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ec-track]');
    if (!link) return;

    publish('eclipse_cta_clicked', {
      cta: cleanValue(link.dataset.ecTrack),
      placement: cleanValue(link.dataset.ecPlacement),
      destination: link.getAttribute('href') || '',
      page_path: window.location.pathname,
      ...attribution,
    });
  });

  const success = document.querySelector('[data-ec-lead-success]');
  if (success) {
    const source = cleanValue(success.dataset.leadSource) || 'size_help';
    const eventKey = `eclipse_lead_published_${source}_${window.location.pathname}`;
    let leadType = 'newsletter';
    if (source.includes('fit') || source === 'size_help') leadType = 'size_assistance';
    if (source === 'partner') leadType = 'partnership';
    if (source === 'contact') leadType = 'contact';
    // Los nombres son los del plan de medición: creator_application y
    // wholesale_application. Si se cambian aquí, hay que cambiarlos en GA4.
    if (source === 'creator') leadType = 'creator_application';
    if (source === 'pro') leadType = 'wholesale_application';

    if (!storageGet(eventKey)) {
      publish('eclipse_lead_submitted', {
        lead_type: leadType,
        source,
        page_path: window.location.pathname,
        ...attribution,
      });
      storageSet(eventKey, '1');
    }

    success.focus();
  }

})();
